import { createNote, updateNote, deleteNote, toggleNoteVisibility } from './effects'
import momentumTemplates from './noteTemplates/momentum.json'

export const UPDATE_PROPS = 'UPDATE_PROPS'
export const GO_TO_CREATE_NOTE = 'GO_TO_CREATE_NOTE'
export const GO_TO_UPDATE_NOTE = 'GO_TO_UPDATE_NOTE'
export const GO_TO_DELETE_NOTE = 'GO_TO_DELETE_NOTE'
export const GO_TO_IMPORT_NOTES = 'GO_TO_IMPORT_NOTES'
export const BACK = 'BACK'
export const EDITOR_CHANGE = 'EDITOR_CHANGE'
export const TOGGLE_NOTE_VISIBILITY = 'TOGGLE_NOTE_VISIBILITY'
export const SHOW_PRIVATE_NOTES_TOGGLE = 'SHOW_PRIVATE_NOTES_TOGGLE'
export const CREATE_NOTE = 'CREATE_NOTE'
export const UPDATE_NOTE = 'UPDATE_NOTE'
export const DELETE_NOTE = 'DELETE_NOTE'
export const USE_TEMPLATE = 'USE_TEMPLATE'
export const LOADING = 'LOADING'

export const actionCreators = (dispatch, state) => ({
  updateProps: (props) =>
    dispatch({
      type: UPDATE_PROPS,
      payload: { props }
    }),
  goToCreateNote: () =>
    dispatch({ type: GO_TO_CREATE_NOTE }),
  goToUpdateNote: (noteIndex) =>
    dispatch({ type: GO_TO_UPDATE_NOTE, payload: { noteIndex } }),
  goToDeleteNote: (noteIndex) =>
    dispatch({ type: GO_TO_DELETE_NOTE, payload: { noteIndex } }),  
  goToImportNotes: () =>
    dispatch({ type: GO_TO_IMPORT_NOTES }),
  back: () =>
    dispatch({ type: BACK }),
  useRoaTemplate: () =>
    dispatch({
      type: USE_TEMPLATE,
      payload: { template: momentumTemplates['RecordOfAdvice'] }
    }),
  useTemplate: (template) =>
    dispatch({
      type: USE_TEMPLATE,
      payload: { template }
    }),
  showPrivateNotesToggle: () =>
    dispatch({ type: SHOW_PRIVATE_NOTES_TOGGLE }),

  // This is an onChange method from the quill component.
  // See https://github.com/zenoamaro/react-quill#api-reference
  onEditerChange: (noteRichText) =>
    dispatch({ type: EDITOR_CHANGE, payload: { noteRichText } }),
  onToggleNoteVisibility: () =>
    dispatch({ type: TOGGLE_NOTE_VISIBILITY }),
  // async actions
  createNote: async (newNote) => {
    dispatch({ type: LOADING })
    await createNote(state, newNote)
    dispatch({ type: CREATE_NOTE })
  },
  toggleNoteVisibility: async (noteIndex) => {
    dispatch({ type: LOADING })
    await toggleNoteVisibility(state, noteIndex)
    dispatch({ type: UPDATE_NOTE })
  },
  updateNote: async (newNote) => {
    dispatch({ type: LOADING })
    await updateNote(state, newNote)
    dispatch({ type: UPDATE_NOTE })
  },
  deleteNote: async () => {
    dispatch({ type: LOADING })
    await deleteNote(state)
    dispatch({ type: DELETE_NOTE })
  }
})
